import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ProductsArrayFeatureCoreModule } from '../productsArray/productsArray-feature.core.module';

import { ApiCmsRenderService } from './infrastructure/api/api-cms-render.service';
import { CmsRenderEffects } from './infrastructure/state/cms-render.effects';
import { cmsRenderReducer } from './infrastructure/state/cms-render.reducer';
import { CmsRenderService } from './ui/services/cms-render/cms-render.service';
import { CountdownService } from './ui/services/countdown/countdown.service';

import { ApiProductsService } from '@api/_api/api-catalog/api-products/api-products.service';
import { ProductsService } from '@api/catalog/products/products.service';
import { AnalyticsCMSModule } from '@shared/analytics/analytics-cms.module';

@NgModule({
    imports: [
        AnalyticsCMSModule,
        StoreModule.forFeature('cms-render', cmsRenderReducer),
        // TODO ECOMDUTI-20989 SSR
        EffectsModule.forFeature([CmsRenderEffects]),
        ProductsArrayFeatureCoreModule,
    ],
    providers: [
        ApiCmsRenderService,
        ApiProductsService,
        CmsRenderService,
        CountdownService,
        ProductsService,
    ],
})
export class CmsRenderCoreModule {

}
